let marqueeContainer = document.querySelector('.marquee'),
    marqueeItem = document.querySelector('.marquee__list'),
    marqueeWrapper = document.querySelector('.marquee__wrapper'),
    marqueeLink = document.querySelector('.marquee__link'),
    multiplier,
    containerWidth,
    marqueeWidth,
    autoFill = true,
    speed = 40;

if (marqueeLink) document.querySelector('body').classList.add('is-marquee')

const calculateWidth = () => {
    if (marqueeItem && marqueeContainer) {
        const containerRect = marqueeContainer.getBoundingClientRect();
        const marqueeRect = marqueeItem.getBoundingClientRect();
        containerWidth = containerRect.width;
        marqueeWidth = marqueeRect.width;

        if (autoFill && containerWidth && marqueeWidth) {
            multiplier = (marqueeWidth < containerWidth ? Math.ceil(containerWidth / marqueeWidth) : 1);
        } else {
            multiplier = 1;
        }
        marqueeContainer.setAttribute('data-children', `${multiplier}`)
        marqueeContainer.style.setProperty('--duration', `${duration()}s`);
        return multiplier;
    }
}

const duration = () => {
    if (autoFill) {
        return (marqueeWidth * multiplier) / speed;
    } else {
        return marqueeWidth < containerWidth
            ? containerWidth / speed
            : marqueeWidth / speed;
    }
}

window.addEventListener('DOMContentLoaded', () => {
    if (marqueeItem && marqueeContainer) {
        const resizeObserver = new ResizeObserver(() => calculateWidth());
        resizeObserver.observe(marqueeContainer);
        resizeObserver.observe(marqueeItem);
        return () => {
            if (!resizeObserver) return;
            resizeObserver.disconnect();
        };
    }
},);

const createChildren = (numberOfChildren) => {
    let marqueeItems = document.querySelectorAll('.marquee__list');
    marqueeItems.forEach(marqueeItem => {
        if (!marqueeItem.hasAttribute('aria-hidden')) {
            for (let i = 0; i < (numberOfChildren - 1); i++) {
                let marqueeInitial = document.querySelector('.marquee__wrapper').cloneNode(true);
                marqueeInitial.classList.remove('marquee__wrapper--initial')
                marqueeInitial.classList.add('marquee__wrapper--cloned');
                marqueeItem.appendChild(marqueeInitial);
            }
        } else if (marqueeItem.hasAttribute('aria-hidden')) {
            for (let i = 0; i < numberOfChildren; i++) {
                let marqueeInitial = document.querySelector('.marquee__wrapper').cloneNode(true);
                marqueeInitial.classList.remove('marquee__wrapper--initial')
                marqueeInitial.classList.add('marquee__wrapper--cloned');
                marqueeItem.appendChild(marqueeInitial);
            }
        }
    })
}

createChildren(calculateWidth())